import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { createSvgIcon } from '@mui/material';

const Minim = () => {

	return (
		<SvgIcon titleAccess=''>
			<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink="http://www.w3.org/1999/xlink"
				xml: space="preserve">
				<path fill="#000000" opacity="1.000000" stroke="none"
					d="M16 3H14V13.56A3.96 3.96 0 0 0 12 13A4 4 0 1 0 16 17V3M12 19A2 2 0 1 1 14 17A2 2 0 0 1 12 19Z" />
			</svg>
		</SvgIcon>
	);
};

export default Minim;
